import { render, staticRenderFns } from "./clipsVideo.vue?vue&type=template&id=4d8c6ad2&scoped=true&"
import script from "./clipsVideo.vue?vue&type=script&lang=js&"
export * from "./clipsVideo.vue?vue&type=script&lang=js&"
import style0 from "./clipsVideo.vue?vue&type=style&index=0&id=4d8c6ad2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8c6ad2",
  null
  
)

export default component.exports